import { Directive, EventEmitter, Input, Output } from '@angular/core';

@Directive({
  selector: 'img[default]',
  host: {
    '(error)': 'updateUrl($event)',
  },
})
export class ImagePreloadDirective {
  @Input({ required: true }) public default: string;
  @Output() public updateProperty: EventEmitter<void> = new EventEmitter<void>();

  public updateUrl(event: Event): void {
    (event.target as HTMLImageElement).src = this.default;
    this.updateProperty.emit();
  }
}
